import React, { Fragment, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import * as authActions from '../../store/actions/authActions';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Switch from '@material-ui/core/Switch';

const Sidebar = () => {
    const [open, setOpen] = useState(false);
    const [activeOpen, setActiveOpen] = useState(false);
    const history = useHistory();

    const userProfile = useSelector(state => state.profile.userProfile);
    const dispatch = useDispatch();

    const logout = async () => {
        dispatch(authActions.logout())
        history.push('/account');
    }

    const getAge = (userDob) => {
        var dob = new Date(userDob);
        var age = (new Date().getFullYear()) - dob.getFullYear();

        return age;
    }

    const handleOpen = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
        setActiveOpen(false);
    }

    const handleConfirm = () => {
        
    }

    return (
        <Fragment>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">Report User</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        For any reporting or technical assistance please refer to the links below:
                        {
                            <div>
                                <h4>User Support: </h4>
                                <a href="https://my.forms.app/donavalon/univrs-feedback-survey" style={{textDecoration:'none'}}>User Support Link</a>
                                <br />
                                <h4>Reporting Users: </h4>
                                <a href="https://my.forms.app/donavalon/univrs-user-report-form" style={{textDecoration:'none'}}>Reporting Users Link</a>
                            </div>
                        }
                    </DialogContentText>
                </DialogContent>
            </Dialog>
            <div className="profile">
                <img className="profile-avatar" src={userProfile.profilePhotos.length === 0 ? 'https://t4america.org/wp-content/uploads/2016/10/Blank-User.jpg' : userProfile.profilePhotos[0].photoUrl} alt="Nothing" height="85px" width="85px" />
                <div className="profile-info">
                    <h2 className="profile-name">{userProfile.profileName}</h2>
                    <p className="profile-age">Age: {getAge(userProfile.dateOfBirth)}</p>
                </div>                
            </div>

            <nav className="chat-nav">
                <div className="chat-nav-item">
                    <Link to="/">
                        <i className="fa fa-home" />
                        Home
                    </Link>
                </div>
                <div className="chat-nav-item">
                    <Link to="/interested">
                        <i className="fa fa-heart"></i> 
                        Interested in You
                    </Link>
                </div>
                <div className="chat-nav-item">
                    <Link to="/conversations">
                        <i className="fa fa-paper-plane"></i> 
                        Messages
                    </Link>
                </div>
                <div className="chat-nav-item">
                    <Link onClickCapture={handleOpen}>
                        <i className="fa fa-ban"></i> 
                        Report
                    </Link>
                </div>
            </nav>

            <div className="admin-controls">

                <div className="admin-control-item">
                    <Link to="/settings">Settings</Link>
                </div>

                <div className="admin-control-item">
                    <button onClick={logout}>logout</button>
                </div>

            </div>
        </Fragment>
    );
};

export default Sidebar;